import { render, staticRenderFns } from "./attachDocumentToTask.vue?vue&type=template&id=0316b33b&scoped=true&"
import script from "./attachDocumentToTask.vue?vue&type=script&lang=js&"
export * from "./attachDocumentToTask.vue?vue&type=script&lang=js&"
import style0 from "./attachDocumentToTask.vue?vue&type=style&index=0&id=0316b33b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0316b33b",
  null
  
)

export default component.exports